import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 items-center gap-8 rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 lg:grid-cols-2 lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-medium text-accent-800">
            <i className="ri-notification-3-line" aria-hidden="true"></i>
            每日速览订阅
          </span>
          <h2 className="mt-4 font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            用一封邮件，看完今天的热点
          </h2>
          <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
            每个工作日傍晚，我们会把当天最值得了解的几条话题时间线整理成一份简短速览发给你。不追热点焦虑，只做读完就够的那种总结。
          </p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <p className="mb-4 font-label text-sm text-foreground-700">留下邮箱，从今天开始收速览。</p>
          <SubscribeForm />
          <p className="mt-4 font-label text-xs text-foreground-500">我们只会用它发送速览，随时可以退订。</p>
        </div>
      </div>
    </section>
  );
}